/**
 * Simplified Modal view that has no mask to obscure the application.
 * Sits on top of other elements/layers on the page.  Delivers a small
 * message to the user that requires user interaction to be closed or
 * given a small timeout duration before it closes itself.
 */
define('glu/core/modal/notificationView',['require','./layerView','hbs!./notification.hbs'],function(require) {
    'use strict';

    var AbsoluteView = require('./layerView'),
        template = require('hbs!./notification.hbs');

    return AbsoluteView.extend({
        template: template,

        className: 'glu-notification-layer',

        initialize: function(opts) {
            AbsoluteView.prototype.initialize.call(this, opts);
            this.message = opts.message || '';
            this.type = opts.type || 'default';
            this.duration = opts.duration || false;
        },

        onRender: function() {
            if (this.duration) {
                var self = this;
                setTimeout(function() {
                    self.remove();
                }, this.duration);
            }
        },

        templateHelpers: function() {
            return {
                message: this.message,
                type: this.type
            };
        }
    });

});

